import React, { Component } from 'react'
import { connect } from 'shalala';
import { Dropdown, Button } from 'react-bootstrap';

import { useStore } from '../../../../store';
import CustomDropdownToggle from '../../../../facturotopia/CustomDropdownToggle';

class CancelacionesTicketsFilters extends Component {

  state = {};
  timerId = null;

  handleOnSelectedFilter = (name, filter) => {
    this.setState({
      [name]: filter !== '' ? filter : ''
    });

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    this.timerId = setTimeout(() => {
      this.submit();
    }, 5000);
  }

  submit = () => {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    const { filters } = this.props;

    this.props.paginate({
      ...filters,
      ...this.state
    });
  }

  getStatusLegend = () => {
    const { status } = this.state;
    let legend = "";

    switch (status) {
      case "10":
        legend = "En proceso"
        break;
      case "1":
        legend = "Cancelados"
        break;
      case "2":
        legend = "No cancelables"
        break;
      case "3":
        legend = "Errores"
        break;
      case "4":
        legend = "Fallidos"
        break;
      default:
        break;
    }

    return legend;
  }

  render() {
    return (
      <div className="mb-1 float-left">
        <Dropdown onSelect={ this.handleOnSelectedFilter.bind(this, 'status') } className="float-left mr-1 pb-2">
          <Dropdown.Toggle as={ CustomDropdownToggle }>
          { this.getStatusLegend() || 'Status' }
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="">Todos</Dropdown.Item>
            <Dropdown.Item eventKey="10">En proceso</Dropdown.Item>
            <Dropdown.Item eventKey="1">Cancelados</Dropdown.Item>
            <Dropdown.Item eventKey="2">No Cancelables</Dropdown.Item>
            <Dropdown.Item eventKey="3">Errores</Dropdown.Item>
            <Dropdown.Item eventKey="4">Fallidos</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Button variant="secondary" className="text-muted float-xs-right float-sm-right float-md-left" onClick={ this.submit }>
          Aplicar
        </Button>
      </div>
    )
  }
}

const mapState = (store) => {
  return store.modulo.cancelaciones.tickets
};

const mapActions = (actions) => {
  return actions.modulo.cancelaciones.tickets;
};

export default connect(useStore, mapState, mapActions)(CancelacionesTicketsFilters);